export const cleanTag = (hashtag: string) => hashtag.replace(/^#/, '');
